import React, { useState } from "react";
import styles from "./styles";
import { TextField, FormControl, MenuItem, Box, Select, Button } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';

const Reservation = function Reservation(props) {
  console.log("Chargement du composant Reservation");

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [convives, setConvives] = useState(2);

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleTimeChange = (event) => {
    setTime(event.target.value);
  };

  const handleConvivesChange = (event) => {
    setConvives(event.target.value);
  };

  const handleSubmit = () => {
    console.log("Date :", date);
    console.log("Heure :", time);
    console.log("Convives :", convives);

  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Reservation</h1>
      
      <p>Sélectionnez une date :</p>
      <TextField
        type="date"
        value={date}
        onChange={handleDateChange}
        style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "10px" }}
      />

      <p>Sélectionnez une heure :</p>
      <TextField
        type="time"
        value={time} 
        onChange={handleTimeChange} 
        inputProps={{ step: 300 }} 
        style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "20px" }}
      />
  
      <p>Indiquez le nombre de convives : </p>
      <Box sx={{ minWidth: 120 }} style={{ backgroundColor: "white" }}>
        <FormControl fullWidth>
          <Select
            labelId="convives-select-label"
            id="convives-select"
            value={convives}
            onChange={handleConvivesChange}
            label="Convives"
          >
            {[...Array(12)].map((_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                {i + 1} {i + 1 === 1 ? "convive" : "convives"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <div style={{display: 'flex', justifyContent: 'center', padding:'1rem'}}>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleSubmit} 
        style={{ marginTop: "20px", padding:'1rem' }}
      ><SendIcon style={{ marginRight: "8px" }} />
        Soumettre
      </Button>
      </div>
    </div>
  );
};

export default Reservation;
